// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import * as d3 from 'd3'
import '../node_modules/panzoom/dist/panzoom'

import '../node_modules/bootstrap-sass/assets/stylesheets/_bootstrap.scss'
import '@/assets/styles/common.scss'

import testData from '../static/testData'

document.getElementById('node_data').value = JSON.stringify(testData)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js